import newsTypes from '../types/newsletter';
import api from "../../api/api";

const setNewsletterList = (array) => ({
    type: newsTypes.SET_NEWSLETTER_LIST,
    array,
});
const setLoading = (boolean) => ({
    type: newsTypes.SET_LOADING,
    boolean,
});


const fetchNewsletters = () => async (dispatch) => {
    dispatch(setLoading(true))
    api.get(`/newsletters?page=1&publishDate=asc`).then(response => lettersResponse(response)).catch(err => lettersError(err));

    const lettersResponse = (response) => {
        const responseData = [];
        // API Platform returns data in hydra:member format
        const dataArray = response.data['hydra:member'] || response.data || [];
        dataArray.forEach((elem) => {
            if (elem.isPublished){
                responseData.push({...elem});
            }
        });
        dispatch(setNewsletterList(responseData));
        dispatch(setLoading(false))
    }

    const lettersError = (err) => {
        console.log(err);
        dispatch(setLoading(false))
    }

};


export default {
    setNewsletterList,
    fetchNewsletters,
};
